import React from "react";

/**
 * Placeholder for the Vendor view page.
 *
 * This file was previously empty, which caused its import in App.js to resolve
 * to `undefined` and crash the entire React tree ("type is invalid" on every
 * route). This minimal valid component restores rendering; replace with the
 * real vendor-detail view when implemented.
 */
const Vendorview = () => {
  return (
    <div data-testid="vendor-view-placeholder" style={{ padding: "24px" }}>
      <h2>Vendor View</h2>
      <p>This page is not yet implemented.</p>
    </div>
  );
};

export default Vendorview;
